































































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { orderBy } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { ReserveCancelCollection, SystemCode } from '@/api'
import {
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  CollectionFlag,
  Prefix,
  SortOrder
} from '@/types'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'

const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'canceledTime',
        headerText: '取消日時',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'canceledBranchCode',
        headerText: '取消館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'canceledPlaceCode',
        headerText: '取消場所',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'canceledReason',
        headerText: '取消理由',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayMaterialFormat',
        headerText: '資料形態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '13',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '14',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayAuthor',
        headerText: '責任表示/年月日号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reservedTime',
        headerText: '登録日',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reservedBranchCode',
        headerText: '登録館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'canceler',
        headerText: '取消者',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '5',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'memo',
        headerText: 'メモ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'remove',
        align: 'center',
        headerText: ''
      }
    ]
  }
]

@Component({
  components: {
    IconBibliography,
    DataTable
  }
})
export default class ReserveCancelCollectionsTable extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: ReserveCancelCollection[]

  @Prop({
    type: Boolean,
    default: false
  })
  edit!: number

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: true
  })
  isTitleLink!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get allCols(): Col[] {
    return COLS
  }

  get cols(): Col[] {
    if (this.edit) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  get sortedItems(): ReserveCancelCollection[] {
    if (this.sortName) {
      return orderBy<ReserveCancelCollection>(
        this.items,
        (item: ReserveCancelCollection) => {
          const propertyValue =
            item[this.sortName as keyof ReserveCancelCollection]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  existsMemo(memo: string | null): boolean {
    return !!memo
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  // ここから資料照会ダイアログ
  openModalBibliographyDetail(
    prefix: Prefix,
    bibliographyId: number,
    bibliographyContentId?: number
  ) {
    if (prefix === Prefix.Set) {
      this.openModalBibliographyDetailSet(
        bibliographyId,
        BibliographyDetailSetTabType.Volume
      )
      return
    }
    this.openModalBibliographyDetailReal(
      bibliographyId,
      BibliographyDetailRealTabType.Collection,
      bibliographyContentId
    )
  }

  openModalBibliographyDetailReal(
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      bibliographyRealId,
      isBibliographySelectProcess: false,
      tabType,
      bibliographyContentId,
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailSet(bibliographyId, tabType)
      }
    })
  }

  openModalBibliographyDetailSet(
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType
  ) {
    this.$modalBibliographyDetailSet.open({
      bibliographySetId,
      isBibliographySelectProcess: false,
      tabType,
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(bibliographyId, tabType)
      }
    })
  }
  // ここまで資料照会

  @Emit('remove')
  onClickRemove(id: number): number {
    return id
  }
}
